module.exports = __webpack_public_path__ + "static/media/5_5.545a71a5.jpg";